import React, { ReactNode, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useAccountSettingByKey } from "@/entities/settings/hooks";
import { resolveBooleanAccountSetting } from "@/entities/settings/accountSettingDefaults";
import { ArrMrrContext, ArrMrrContextValue } from "./context";

interface ArrMrrProviderProps {
  children: ReactNode;
}

export const ArrMrrProvider: React.FC<ArrMrrProviderProps> = ({ children }) => {
  const settingResult = useAccountSettingByKey("is_arr");
  const { t } = useTranslation();

  const contextValue: ArrMrrContextValue = useMemo(() => {
    const isArr = resolveBooleanAccountSetting(
      "is_arr",
      settingResult.data?.value
    );
    const fieldName = isArr ? "arr" : "mrr";

    return {
      isArr,
      fieldName,
      getValue: (deal: any) => deal?.[fieldName],
      label: t(`terms.${fieldName}`),
      isLoading: settingResult.isLoading,
      isResolved: settingResult.isSuccess,
      error: settingResult.error,
      refetch: settingResult.refetch
    };
  }, [
    settingResult.data?.value,
    settingResult.isLoading,
    settingResult.isSuccess,
    settingResult.error,
    settingResult.refetch,
    t
  ]);

  return (
    <ArrMrrContext.Provider value={contextValue}>
      {children}
    </ArrMrrContext.Provider>
  );
};
